module.exports = __webpack_public_path__ + "img/export2.54fe38d1.svg";